/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { useQuery } from 'react-query';
import Edit from '@material-ui/icons/Edit';
import { getUpdatedUserEmail } from '../../../../state/ducks/Common/Common-Selectors';
import { getIsAuthenticatedStatus, getProfileInfo } from '../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { fetchEmailSubscribeStatus } from '../../../../../../../apis/account-apis/fetchEmailSubscribeStatus';
import { getCurrentBrandId } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

const styles = (theme) => ({
    messageWidth: {
        width: '100%',
        maxWidth: 300,
    },
    verticalAlignMiddle: {
        verticalAlign: 'middle',
    },
    labelName: {
        color: theme.palette.grey[600],
    },
});

const DesktopAccountEmailPreference = ({ classes }) => {
    const email = useSelector(getUpdatedUserEmail);
    const isAuthenticated = useSelector(getIsAuthenticatedStatus);
    const userProfile = useSelector(getProfileInfo);
    const brandId = useSelector(getCurrentBrandId);
    const history = useHistory();

    const brandsEmailOpt = {
        FB: '18B',
        FBQ: '18B',
        HD: 'HND',
        WF: 'WLF',
        BRY: 'BERRIES',
        VC: 'VTC',
        CSG: 'CL',
    };

    const brand = brandsEmailOpt[brandId] || brandId || '18F';

    const { data } = useQuery({
        queryKey: ['fetchEmailSubscribeStatus', userProfile?.email],
        queryFn: () => {
            if (isAuthenticated && userProfile?.email) {
                return fetchEmailSubscribeStatus({
                    retrieveEmailRequest: 
                        {
                            email: userProfile.email,
                            siteId: brand,
                            sourceSystem: "SSP",
                        }
                });
            }
            return null;
        },
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        enabled: isAuthenticated && !!userProfile?.email,
    });

    const isUserSubscribedToMarketingEmails = data?.data?.retrieveEmailResponse?.retrieveEmailResponseResult?.retrieveEmailResult?.retrieveEmailMessage === 'Active';

    const copyTemplate = () => {
        return (
            <>
                <div className={`padding-top padding-bottom-2x bold ${classes.messageWidth}`}>
                    <p className="margin-bottom">
                        {isUserSubscribedToMarketingEmails
                            ? 'You are currently signed up to receive our emails!'
                            : 'Sign up to receive emails about our special offers!'}{' '}
                    </p>
                </div>
            </>
        );
    };

    return (
        <>
            <div className="padding">
                {copyTemplate()}
                <div className="padding-top padding-bottom-2x">
                    <span className={classes.labelName}> Email: </span>
                    <span className="bold">{email}</span>
                </div>
                <div className="blue-color align-right">
                    <span className="link-button" role="presentation" onClick={() => history.push('/account/email-preference')}>
                        <Edit className={`link-icon ${classes.verticalAlignMiddle}`} />
                        <span className="link-label">Edit</span>
                    </span>
                </div>
            </div>
        </>
    );
};

DesktopAccountEmailPreference.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(DesktopAccountEmailPreference);